import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UserMembershipPageComponent } from './user-membership-page.component';
import { UserMembershipRoutingModule } from './user-membership-page-routing.module';
import { UtilitiesModule } from '../../utilities/utilities.module';

@NgModule({
    declarations: [UserMembershipPageComponent],
    imports: [
        CommonModule,
        UserMembershipRoutingModule,
        FlexLayoutModule,
        MatDividerModule,
        MatRippleModule,
        MatIconModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        UtilitiesModule,
    ],
})
export class UserMembershipPageModule {}
